import { render, staticRenderFns } from "./ModalGetOffer.vue?vue&type=template&id=2f81dba5&"
import script from "./ModalGetOffer.vue?vue&type=script&lang=js&"
export * from "./ModalGetOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports